import { render } from "./PedidoCompraFreteVolume.vue?vue&type=template&id=0940b7a2&ts=true"
import script from "./PedidoCompraFreteVolume.vue?vue&type=script&lang=ts"
export * from "./PedidoCompraFreteVolume.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__